import { InjectionToken } from '@angular/core';

export const ENVIRONMENT: InjectionToken<unknown> = new InjectionToken<unknown>(
    'Application environment token to share the config across app and libraries.'
);
